var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysiciansMarketingEnrollment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    enableBackground: "new 0 0 88 88",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000111167231612020835430000016871527548359485365_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    d: "M57.9,54.2l3.8-3.4c0.2-0.2,0.5-0.2,0.7,0 l1.1,0.9c0.2,0.2,0.5,0.2,0.7-0.1c0,0,0,0,0,0l3.8-3.8c0.2-0.2,0.5-0.2,0.7-0.1l2.9,1.9c0.2,0.1,0.5,0.1,0.6-0.1l5-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#CBBE53",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    d: "M77.4,46.6l-5.1,3.8c-0.2,0.1-0.4,0.2-0.6,0.1 L68.8,49c-0.2-0.1-0.5-0.1-0.6,0.1l-3.9,3.1c-0.2,0.1-0.5,0.1-0.7,0l-1.1-0.6c-0.2-0.1-0.5-0.1-0.7,0l-3.9,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#A09648",
    strokeWidth: 0.37,
    strokeMiterlimit: 10,
    d: "M77.4,48.5l-5.2,2.9c-0.2,0.1-0.4,0.1-0.6,0 l-2.8-1.1c-0.2-0.1-0.4-0.1-0.6,0.1l-3.9,2.3c-0.2,0.1-0.5,0.1-0.7,0l-1.1-0.5c-0.2-0.1-0.4-0.1-0.6,0l-3.9,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#746F3C",
    strokeWidth: 0.37,
    strokeMiterlimit: 10,
    d: "M77.5,50.4l-5.3,1.9c-0.2,0.1-0.4,0.1-0.6,0 l-2.7-0.8c-0.2-0.1-0.4-0.1-0.6,0l-4,1.5c-0.2,0.1-0.4,0.1-0.6,0l-1.1-0.4c-0.2-0.1-0.4-0.1-0.6,0l-4,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#494731",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    d: "M77.5,52.3l-5.3,0.9c-0.2,0-0.4,0-0.5,0 L69,52.8c-0.2,0-0.4,0-0.6,0l-4.1,0.8c-0.2,0-0.4,0-0.6,0l-1.1-0.2c-0.2,0-0.4,0-0.6,0l-4,0.8"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D2025",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    x1: 77.6,
    y1: 54.2,
    x2: 57.9,
    y2: 54.2
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    points: "57.9,44.9 57.9,54.2 77.6,54.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    d: "M47.8,62.2c-0.1-0.1-0.3,0-0.4,0.1 c-1.3,1.9-3.9,2.5-5.8,1.2c-0.5-0.3-0.9-0.7-1.2-1.2c-0.1-0.1-0.2-0.2-0.4-0.1c-1.9,0.8-3.1,2.6-3.1,4.7v1.8 c0,1.4,1.1,2.5,2.5,2.5c0,0,0,0,0,0h9c1.4,0,2.5-1.1,2.5-2.5v-1.8C50.9,64.8,49.7,63,47.8,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C1B451",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    d: "M40.9,63.4c-1.5,0.6-2.4,2-2.4,3.6v0.5 c0,0.2,0,0.6,0.1,1c0,1,0.9,1.9,1.9,1.9h6.9c1,0,1.9-0.8,1.9-1.9c0-0.3,0.1-0.6,0.1-1V67c0-1.6-1-3-2.4-3.6c-0.1,0-0.2,0-0.3,0.1 c-1,1.5-3,1.9-4.5,0.9c-0.4-0.2-0.7-0.5-0.9-0.9C41.2,63.4,41,63.4,40.9,63.4C40.9,63.4,40.9,63.4,40.9,63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8A8342",
    strokeWidth: 0.37,
    strokeMiterlimit: 10,
    d: "M41.8,64.7c-1,0.4-1.7,1.4-1.7,2.5v0.4 c0,0.3,0.1,0.5,0.1,0.8c0,0.7,0.6,1.3,1.4,1.3h4.7c0.7,0,1.3-0.5,1.4-1.3c0.1,0,0.1-0.7,0.1-0.7v-0.4c0-1.1-0.7-2.1-1.7-2.5 c-0.1,0-0.1,0-0.2,0.1c-0.8,1.1-2.2,1.3-3.3,0.5c-0.2-0.2-0.4-0.3-0.5-0.5C41.9,64.6,41.9,64.6,41.8,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#545134",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    d: "M42.7,65.9c-0.6,0.2-1,0.8-1,1.5v0.3 c0,0.2,0.1,0.3,0.2,0.5c0,0.4,0.4,0.6,0.8,0.6h2.6c0.3,0,0.8-0.3,0.8-0.6c0.1,0,0.2-0.4,0.2-0.5v-0.3c0-0.7-0.4-1.2-1-1.5 c0,0-0.1,0-0.1,0c-0.3,0.4-0.7,0.5-1.1,0.5c-0.4,0-0.8-0.2-1.1-0.5C42.8,65.9,42.8,65.8,42.7,65.9C42.7,65.8,42.7,65.9,42.7,65.9z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D2025",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    d: "M44.2,67.1c-0.1,0.1-0.6,0.1-0.7,0 c-0.2,0.1-0.3,0.2-0.3,0.4v0.2c0,0.1,0.1,0.2,0.2,0.2l0,0h0.8c0.1,0,0.2-0.1,0.2-0.2v-0.2C44.6,67.3,44.4,67.1,44.2,67.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    cx: 43.9,
    cy: 60,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#C1B451",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    cx: 43.9,
    cy: 60,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#8A8342",
    strokeWidth: 0.37,
    strokeMiterlimit: 10,
    cx: 43.9,
    cy: 60,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#545134",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    cx: 43.9,
    cy: 60,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1D2025",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    cx: 43.9,
    cy: 60,
    r: 0.3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    points: "28.1,37.2 12.4,37.2 4.5,50.8  12.4,64.5 28.1,64.5 36,50.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#D8C957",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    points: "27.3,38.5 13.1,38.5 6,50.8 13.1,63.1  27.3,63.1 34.4,50.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#B9AD4E",
    strokeWidth: 0.37,
    strokeMiterlimit: 10,
    points: "26.5,39.9 13.9,39.9 7.6,50.8  13.9,61.8 26.5,61.8 32.9,50.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#9A9146",
    strokeWidth: 0.37,
    strokeMiterlimit: 10,
    points: "25.8,41.3 14.7,41.3 9.2,50.8  14.7,60.4 25.8,60.4 31.3,50.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#7A743E",
    strokeWidth: 0.37,
    strokeMiterlimit: 10,
    points: "25,42.6 15.5,42.6 10.8,50.8 15.5,59  25,59 29.7,50.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#5B5836",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    points: "24.2,44 16.3,44 12.4,50.8 16.3,57.7  24.2,57.7 28.1,50.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#3C3C2D",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    points: "23.4,45.4 17.1,45.4 13.9,50.8  17.1,56.3 23.4,56.3 26.5,50.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1D2025",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    points: "22.6,46.7 17.9,46.7 15.5,50.8  17.9,54.9 22.6,54.9 25,50.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    points: "75.7,9.8 59.9,9.8 52,23.5 59.9,37.2  75.7,37.2 83.5,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#D8C957",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    points: "74.9,11.2 60.7,11.2 53.6,23.5  60.7,35.8 74.9,35.8 82,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#B9AD4E",
    strokeWidth: 0.37,
    strokeMiterlimit: 10,
    points: "74.1,12.6 61.5,12.6 55.1,23.5  61.5,34.4 74.1,34.4 80.4,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#9A9146",
    strokeWidth: 0.37,
    strokeMiterlimit: 10,
    points: "73.3,13.9 62.2,13.9 56.7,23.5  62.2,33.1 73.3,33.1 78.8,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#7A743E",
    strokeWidth: 0.37,
    strokeMiterlimit: 10,
    points: "72.5,15.3 63,15.3 58.3,23.5 63,31.7  72.5,31.7 77.2,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#5B5836",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    points: "71.7,16.7 63.8,16.7 59.9,23.5  63.8,30.3 71.7,30.3 75.7,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#3C3C2D",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    points: "70.9,18 64.6,18 61.5,23.5 64.6,29  70.9,29 74.1,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1D2025",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    points: "70.1,19.4 65.4,19.4 63,23.5  65.4,27.6 70.1,27.6 72.5,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    points: "51.9,50.8 36.1,50.8 28.2,64.5  36.1,78.2 51.9,78.2 59.8,64.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    points: "51.9,23.5 36.1,23.5 28.2,37.2  36.1,50.8 51.9,50.8 59.8,37.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    points: "4.5,23.5 12.4,37.2 28.1,37.2  36,23.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    points: "83.4,78.2 75.5,64.5 59.8,64.5  51.9,78.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    points: "75.7,37.2 59.9,37.2 52,50.8  59.9,64.5 75.7,64.5 83.5,50.8  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 28.1,
    cy: 64.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 36,
    cy: 50.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 52,
    cy: 50.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 59.8,
    cy: 64.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 83.5,
    cy: 50.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 75.8,
    cy: 37.2,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 59.8,
    cy: 37.2,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 52,
    cy: 23.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 36,
    cy: 23.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 4.5,
    cy: 23.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 28.2,
    cy: 37.2,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 12.4,
    cy: 37.2,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 4.5,
    cy: 50.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 12.4,
    cy: 64.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 75.8,
    cy: 64.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E55F",
    stroke: "#F7E55F",
    strokeWidth: 0.14,
    strokeMiterlimit: 10,
    cx: 83.5,
    cy: 23.5,
    r: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiciansMarketingEnrollment);
export default __webpack_public_path__ + "static/media/physiciansMarketingEnrollment.cd63b57e54ccc0846dc8255583e777c2.svg";
export { ForwardRef as ReactComponent };